__turbopack_context__.v({
  "AdvantageCard__container": "CampusCard-module-scss-module__jj86RW__AdvantageCard__container",
  "AdvantageCard__image": "CampusCard-module-scss-module__jj86RW__AdvantageCard__image",
  "AdvantageCard__subtitle": "CampusCard-module-scss-module__jj86RW__AdvantageCard__subtitle",
  "AdvantageCard__textContainer": "CampusCard-module-scss-module__jj86RW__AdvantageCard__textContainer",
  "AdvantageCard__title": "CampusCard-module-scss-module__jj86RW__AdvantageCard__title",
  "AdvantageCard__titleOnly": "CampusCard-module-scss-module__jj86RW__AdvantageCard__titleOnly",
  "ProgramHighlight_img": "CampusCard-module-scss-module__jj86RW__ProgramHighlight_img",
});
